import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/material-kit-react/views/learningPage.js";
import swal from 'sweetalert'
import md5 from "md5";

import {
  useParams
} from "react-router-dom";
const useStyles = makeStyles(styles);

export default function LearningCertificatePage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  let { id } = useParams();
    const [state, setState] = React.useState({
    code: "",
    url:null
  });
  useEffect(()=>{
    setState({ ...state, ["url"]: "/Classes/Certificate/"+md5(id)+".png" });
  },[])
 
  function AsDefault() {
    setState({ ...state, ["url"]: "/Classes/Certificate/filenotfound.jpg" });
    //swal("گواهینامه یافت نشد.")
  }
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
    return (
      <div>
        <Header
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 30,
            color: "white"
          }}
          {...rest}
        />
        <Parallax verySmall filter image={require("assets/img/bg17.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
    
            <div className={classes.container}>
<GridContainer>
<GridItem  className={classes.center+" "+classes.box}  xs={12} sm={12} md={12}>
  <br />
  <br />
  گواهینامه کد : {id}
</GridItem>
            <GridItem  className={classes.center}  xs={12} sm={12} md={12}>
  <img className={classes.img} src={state.url} onError={()=>AsDefault()}></img>
  <br />
  <br /> <br />
  <br />
</GridItem>
</GridContainer>

              <div>
              </div>
              <div className={classes.description}>
                <p>
                  {" "}
                </p>
              </div>
              <GridContainer justify="center">
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
                    }
